import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '@/app/core/services/auth.service';
import { HasRoleDirective } from "@/app/directives/has-role.directive";
import { AccountInfo } from '@azure/msal-browser';
import { getPath, PathUnit } from '@/app/consts/path.const';
import { HeaderService } from './header.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, TegelModule, HasRoleDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  private authService = inject(AuthService);
  private headerService = inject(HeaderService);
  
  selectedStorage$ = new BehaviorSubject<string>('');
  devStorageLabel = 'Development Storage';
  prodStorageLable = 'Production Storage';
  devStorageUrl = '/dev-storage';
  prodStorageUrl = '/prod-storage';
  activeHeaderItem = '';
  profilePic: string | null = null;
  default = 'assets/icons/default-profile.svg';
  profile = {
    name: 'User Name',
    jobTitle: 'Job Title',
    email:"userName@email.com"
  };
  systemSettingPath = getPath(PathUnit.SystemSettings);
  landingPage = getPath(PathUnit.LandingPage);
  mobileNavOpen = this.headerService.mobileNavOpen;
  ngOnInit(){
    const msalInstance = this.authService.currentMsalService().instance;
    const accountInfo: AccountInfo | null = msalInstance.getActiveAccount();

    if (accountInfo) {
      this.profile.name = accountInfo.name ?? 'User Name';
      this.profile.email = accountInfo.username ?? '';
    }

    // if user only has Guest role then keep it otherwise set job titles excluding Guest
    const roles = this.authService.getCurrentUserRoles().filter(role => role !== 'Guest');
    this.profile.jobTitle = roles.length > 0 ? roles.join(', ') : 'Guest';
  }
  
  toggleMobileSideMenu() {
    this.headerService.toggleMobileSideMenu();
  }

  updateSelectedStorage(storage: string) {
    this.selectedStorage$.next(storage);
  }

  logout(){
    this.authService.fullLogout()
  }

  isAdmin(): boolean {
    // Implementation for admin check
    return true;
  }
} 